import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./moreFromThisProviderV2.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { buildListingCategory, flattenBusinessNeeds } from '~/modules/helpers/categoryHelper';
import { getListingLogo } from '~/modules/helpers/listingHelper';
import { generateBaseUrl } from '~/modules/helpers/routingHelper';
import { Routes } from '~/modules/routes';
import { i18nStore, WireI18n } from '~/modules/stores/i18nStore';
import { MIN_PROVIDER_LISTINGS_TO_DISPLAY, moreFromProviderStore, MoreFromThisProviderLoadingStatus, V2_PROVIDER_LISTINGS_TO_DISPLAY } from '~/modules/stores/moreFromProviderStore';
import { shuffle } from '~/modules/utilities/arrayUtilities';
import { selectExtensionListing } from '~/modules/utilities/listing_utils';

/**
 * Supplies same-provider listing data and generic listing tiles to the shared Listing Detail V2
 * recommendation carousel. Carousel layout, styling, and paging live in recommendationCarousel.
 */
class MoreFromThisProviderV2 extends LightningElement {
  constructor(...args) {
    super(...args);
    this.providerName = '';
    // Preserve locale-change reactivity; the interpolated title getter reads the callable store.
    this.
    // @ts-expect-error * Automated Type Error Fix
    i18n = null;
    this.
    // @ts-expect-error * Automated Type Error Fix
    providerState = null;
    // `shuffle` re-randomizes on every call, so memoize the mapped+shuffled set against the store's
    // listings reference. Paging state changes inside the shared carousel cannot reorder the cards.
    this.listingsRef = null;
    this.memoizedProviderListings = [];
  }
  get isLoading() {
    return this.providerState.loadingStatus === MoreFromThisProviderLoadingStatus.LOADING;
  }
  get isError() {
    return this.providerState.loadingStatus === MoreFromThisProviderLoadingStatus.ERROR;
  }
  get displayMoreFromThisProvider() {
    return this.providerState?.data?.listings?.length >= MIN_PROVIDER_LISTINGS_TO_DISPLAY && !this.isLoading && !this.isError;
  }
  get providerListings() {
    const listings = this.providerState.data?.listings;
    if (listings === this.listingsRef) {
      return this.memoizedProviderListings;
    }
    this.listingsRef = listings;
    this.memoizedProviderListings = shuffle(listings?.map(listing => ({
      oafId: listing.oafId,
      tzId: listing.tzId,
      appExchangeId: listing.appExchangeId,
      id: listing.external_id,
      listingUrl: `${generateBaseUrl()}/${Routes.LISTING}?listingId=${listing.external_id}&channel=recommended`,
      averageRating: listing.reviewsSummary?.averageRating ?? 0,
      reviewsAmount: listing.reviewsSummary?.reviewCount ?? 0,
      publisher: this.providerName,
      listingCategories: flattenBusinessNeeds(listing.businessNeeds).map(buildListingCategory),
      image: getListingLogo(listing),
      title: listing.name,
      description: listing.description,
      type: this.getListingType(listing)
    })) ?? [], V2_PROVIDER_LISTINGS_TO_DISPLAY);
    return this.memoizedProviderListings;
  }
  get providerListingCount() {
    return this.providerListings.length;
  }
  get title() {
    return i18nStore.getState().i18n.heading.moreFromProvider({
      PROVIDER_NAME: this.providerName
    });
  }
  get previousLabel() {
    return this.i18n?.moreFromProvider?.previousListings ?? '';
  }
  get nextLabel() {
    return this.i18n?.moreFromProvider?.nextListings ?? '';
  }

  // @ts-expect-error * Automated Type Error Fix
  getListingType(listing) {
    const extension = selectExtensionListing(listing);
    return extension.recordType;
  }

  // Preserve the existing `recommended` analytics contract emitted by generic listing tiles.
  handleAnalytics(event) {
    event.detail.tiles = this.props;
  }
  handleTrackScroll() {
    this.template?.querySelectorAll('wds-listing-tile').forEach(tile => {
      tile.checkVisibility();
    });
  }
  get props() {
    return {
      title: this.title,
      name: 'recommended',
      format: 'listing'
    };
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(MoreFromThisProviderV2, {
  publicProps: {
    providerName: {
      config: 0
    }
  },
  wire: {
    i18n: {
      adapter: WireI18n,
      config: function ($cmp) {
        return {};
      }
    },
    providerState: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: moreFromProviderStore
        };
      }
    }
  },
  fields: ["listingsRef", "memoizedProviderListings"]
});
const __lwc_component_class_internal = _registerComponent(MoreFromThisProviderV2, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;